import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { signinRedirectCallback } from '../../services/userService';

function SigninOidc() {
  const history = useHistory();
  useEffect(() => {
    async function signinAsync() {
      await signinRedirectCallback().catch((e) => {
        // await error happens when SIGNIN -> LOAD PAGE -> history.goBack()
        // catch this so it could proceed to redirecting to '/'
      });

      history.push('/');
    }
    signinAsync();
  }, [history]);

  return <div>Redirecting...</div>;
}

export default SigninOidc;
